import React from 'react';
import { IoMdSettings } from 'react-icons/io';

const RecordingControls = ({
    isRecording,
    startRecording,
    isUploading,
    isPaused,
    onPauseResume,
    countdown,
    helpButton,
    onSettingsClick,
    onAbort
}) => {
    return (
        <div className="controls">
            {!isRecording ? (
                <>
                    <button onClick={onSettingsClick} className="settings-button">
                        <IoMdSettings style={{ width: '24px', height: '24px' }} />
                    </button>
                    <button onClick={startRecording} className="record-button">
                        Start Recording (Press Space)
                    </button>
                    {helpButton}
                </>
            ) : (
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    {!isUploading && countdown > 0 && (
                        <>
                            <button
                                onClick={onPauseResume}
                                className={`pause-button ${isPaused ? 'paused' : ''}`}
                            >
                                {isPaused ? 'Resume Recording' : 'Pause Recording'}
                            </button>
                            <button
                                onClick={onAbort}
                                className="abort-button"
                            >
                                Abort Recording (Esc)
                            </button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default RecordingControls; 
